import WallexService from './WallexService'
import { DeductionCreatePayload, DeductionUpdatePayload, DeductionRetrieve } from '../domain/Deduction'

export default class DeductionService extends WallexService {
    public static create(payload: DeductionCreatePayload): Promise<DeductionRetrieve> {
        return this.instance()
            .post('deduction', payload)
            .then((response) => {
                const body = response.data as {
                    result: DeductionRetrieve
                }

                return body.result
            })
            .catch((e) => {
                throw e
            })
    }

    public static retrieve(deductionId: string): Promise<DeductionRetrieve> {
        return this.instance()
            .get('deduction/' + deductionId)
            .then((response) => {
                const body = response.data as {
                    result: DeductionRetrieve
                }

                return body.result
            })
    }

    public static update(payload: DeductionUpdatePayload): Promise<DeductionRetrieve> {
        return this.instance()
            .patch('deduction', payload)
            .then((response) => {
                const body = response.data as {
                    result: DeductionRetrieve
                }

                return body.result
            })
    }
}
